const AgeUtils = require('hooks/useFormPrimitives/ageUtils');

Object.assign(exports, AgeUtils);

exports.buildBirthdateChange = (age) => {
    const birthdate = AgeUtils.buildBirthdateFromAge(age);

    return {
        state: {
            birthdate,
            pageIsBlocking: true
        },
        progressAction: {
            field: 'birthdate',
            payload: {
                birthdate
            }
        }
    };
};
